import { DataMetrics, WorkComWrapper, WorkComCriteria, BasicScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { WorkcomDataload } from '../../vo/workflow/workcom.dataload';

/**
 * appels pour synchro des Workcoms remote
 */
export class WorkcomCountCmd extends WizCommand<DataMetrics> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }
  
  public dataLoad: WorkcomDataload; // le pool de chargement
 
  /** retourne un wrapper pre-alimenté pour un appel complet du FD (avec values) */
  public  wrapper(): WorkComWrapper {
    const wrapper: WorkComWrapper = new WorkComWrapper();
    wrapper.criteria = new WorkComCriteria();
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.criteria.visionCode = this.model.visionCode;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }

  /** 
   * compte les Workcoms et EMs sur le périmètre
   * 
   * @param dataload le pool de chargement
   * @param freedataCode cible, pour refresh avant commit
   * @param callback de retour
   * @returns la commande préparée
   */
  public count(dataload: WorkcomDataload, callback?: Function): WorkcomCountCmd {
    this.dataLoad = dataload;

    const wrapper: WorkComWrapper = this.wrapper();
    wrapper.criteria.revisionNumber = this.dataLoad.revisionNumber; // par numRev
    
    this.configureRemote(ExternalAPI.WORKCOM_COUNT_API, wrapper, callback);
    return this;
  }


  public wizResult(): void {
    super.wizResult();
    if (this.result) {
      let metrics: DataMetrics = this.result;
      this.dataLoad.state = WorkcomDataload.LOADING;
      this.dataLoad.nbWorkcoms = metrics.nbLines; // on recycle les lignes
      this.dataLoad.nbDeleteds = metrics.nbDeleted;
      this.dataLoad.remoteRevisionNumber = metrics.numRev;
    } else {
      console.log('WorkcomCountCmd no result');
    }
  }
}
